export function loadbmap(callback) {
  // 检查是否已经加载过百度地图API
  if (window.BMap) {
    console.log('百度地图API已加载，直接执行回调');
    // 验证API是否正常工作
    if (window.BMap.Geolocation) {
      console.log('百度地图定位服务可用');
    } else {
      console.warn('百度地图API已加载但定位服务不可用');
    }
    if (typeof window[callback] === 'function') {
      window[callback]();
    }
    return;
  }

  const ak = 'HsmFqK282H7iYeZmclkH4gL9nUUz318e';
  console.log('开始加载百度地图API，AK:', ak);
  console.log('当前域名:', window.location.hostname);
  console.log('当前协议:', window.location.protocol);

  var script = document.createElement('script')
  // 使用HTTPS协议，提高在HTTPS环境下的兼容性
  script.src = `https://api.map.baidu.com/api?v=2.0&ak=${ak}&callback=${callback}`
  
  // 设置超时检测
  const timeout = setTimeout(() => {
    console.error('百度地图API加载超时（30秒）');
    script.remove();
    handleLoadFailure('加载超时');
  }, 30000);
  
  // 添加错误处理
  script.onerror = function(error) {
    clearTimeout(timeout);
    console.error('百度地图API脚本加载失败:', error);
    console.error('失败的URL:', script.src);
    
    // 如果HTTPS失败，尝试HTTP（在非HTTPS环境下）
    if (script.src.startsWith('https://') && location.protocol === 'http:') {
      console.log('尝试使用HTTP协议加载百度地图API');
      script.remove();
      var fallbackScript = document.createElement('script');
      fallbackScript.src = `http://api.map.baidu.com/api?v=2.0&ak=${ak}&callback=${callback}`;
      
      const fallbackTimeout = setTimeout(() => {
        console.error('HTTP协议加载也超时');
        fallbackScript.remove();
        handleLoadFailure('HTTP协议加载超时');
      }, 30000);
      
      fallbackScript.onerror = function(fallbackError) {
        clearTimeout(fallbackTimeout);
        console.error('HTTP协议加载也失败:', fallbackError);
        handleLoadFailure('HTTP和HTTPS协议都失败');
      };
      
      fallbackScript.onload = function() {
        clearTimeout(fallbackTimeout);
        console.log('HTTP协议加载百度地图API成功');
        validateApiAndCallback();
      };
      
      document.body.appendChild(fallbackScript);
    } else {
      handleLoadFailure('脚本加载失败');
    }
  };
  
  script.onload = function() {
    clearTimeout(timeout);
    console.log('百度地图API脚本加载成功');
    validateApiAndCallback();
  };
  
  // 验证API并执行回调
  function validateApiAndCallback() {
    // 等待一小段时间确保API完全初始化
    setTimeout(() => {
      if (window.BMap) {
        console.log('百度地图API对象创建成功');
        
        // 检查关键服务是否可用
        if (window.BMap.Geolocation) {
          console.log('✓ 百度地图定位服务可用');
        } else {
          console.warn('✗ 百度地图定位服务不可用');
        }
        
        if (window.BMap.Map) {
          console.log('✓ 百度地图Map服务可用');
        } else {
          console.warn('✗ 百度地图Map服务不可用');
        }
        
        // 检查是否有AK相关的错误
        if (window.BMap.apiLoad === false) {
          console.error('百度地图API加载失败，可能是AK问题');
          handleLoadFailure('AK验证失败');
          return;
        }
        
      } else {
        console.error('百度地图API对象未创建，可能是AK无效');
        handleLoadFailure('API对象未创建');
        return;
      }
      
      // 执行回调
      if (typeof window[callback] === 'function') {
        window[callback]();
      }
    }, 1000);
  }
  
  // 处理加载失败
  function handleLoadFailure(reason) {
    console.error(`百度地图API加载失败: ${reason}`);
    console.error('可能的原因:');
    console.error('1. AK无效或已过期');
    console.error('2. 域名未在百度地图控制台白名单中');
    console.error('3. AK权限不足（缺少定位服务权限）');
    console.error('4. 网络连接问题');
    console.error('5. 百度地图服务暂时不可用');
    
    // 执行失败回调，让页面能够继续运行
    if (typeof window[callback] === 'function') {
      window[callback]();
    }
  }
  
  document.body.appendChild(script)
}

// 导出AK验证函数
export function validateBaiduAK() {
  const ak = 'HsmFqK282H7iYeZmclkH4gL9nUUz318e';
  const testUrl = `https://api.map.baidu.com/api?v=2.0&ak=${ak}&callback=testCallback`;
  
  console.log('验证百度地图AK...');
  console.log('AK:', ak);
  console.log('测试URL:', testUrl);
  console.log('当前域名:', window.location.hostname);
  
  return new Promise((resolve, reject) => {
    window.testCallback = function() {
      if (window.BMap) {
        console.log('✓ AK验证成功');
        resolve(true);
      } else {
        console.error('✗ AK验证失败');
        reject(false);
      }
      delete window.testCallback;
    };
    
    const script = document.createElement('script');
    script.src = testUrl;
    script.onerror = () => {
      console.error('✗ AK验证请求失败');
      reject(false);
      delete window.testCallback;
    };
    
    setTimeout(() => {
      if (window.testCallback) {
        console.error('✗ AK验证超时');
        reject(false);
        delete window.testCallback;
        script.remove();
      }
    }, 10000);
    
    document.body.appendChild(script);
  });
}
